<template>
  <div class="">
    <mandate-codes> </mandate-codes>
  </div>
</template>

<script>
import MandateCodes from "@/components/profile/companies-products/mandate-codes/index.vue";
export default {
  props: {
    msg: String,
  },
  components: {
    MandateCodes,
  },
  created() {},
};
</script>
